import React, { useState } from "react";
import {
  RainfallSettingArray,
  SimulationListType,
  PlyFileURLListType,
  SimulationResults,
  // PlyFileNameURLListType,
} from "../types/type";
import { useFileData } from "./FileDataContext";
import { is } from "@react-three/fiber/dist/declarations/src/core/utils";

type Props = {
  setIsSettingWindowOpen: any;
  setDataListState: any;
  setModalType: any;
  getSimulationsList: any;
  getSimulationData: any;
  getPastFutureInputData: any;
  simulationList: SimulationListType;
  plyFileURLList: SimulationResults;
  setIsLoading: any;
  setimeSlot: any;
  postCancelSimulation: any;
  getSimulationPlyData: any;
  setReferenceDateTime: (newState: Date | ((prevState: Date) => Date)) => void;
  getPastData: any;
  user: any;
};

export const SimulationList = (props: Props) => {
  const {
    setIsSettingWindowOpen,
    setDataListState,
    setModalType,
    getSimulationsList,
    getSimulationData,
    getPastFutureInputData,
    simulationList,
    plyFileURLList,
    setIsLoading,
    setimeSlot,
    postCancelSimulation,
    getSimulationPlyData,
    setReferenceDateTime,
    getPastData,
    user,
  } = props;
  const { setFileData } = useFileData();

  const onResultButtonClick = async (simu_id: string) => {
    // サーバーから署名付きURLと時間帯リストを取得
    setIsLoading(true);

    try {
      const plyFileData: PlyFileURLListType = await getSimulationPlyData(
        simu_id
      );

      // console.log("★plyFileData = ", plyFileData);
      // console.log("★plyFileData.results = ", plyFileData.results)
      // console.log("★(plyFileData && plyFileData.results) = ", (plyFileData && plyFileData.results))

      // TimeSlotを設定
      console.log(plyFileData);
      setimeSlot(plyFileData.results.time_slot);

      // 全plyFileURLList.PlyFileNameURLListのsigned_urlを用いてplyファイルを全てダウンロード
      if (plyFileData && plyFileData.results) {
        let floodFiles: Blob[] = [];
        let landFile: Blob | null = null;
        let buildingFile: Blob | null = null;
        let pngFiles: Blob[] = [];

        for (const fileInfo of plyFileData.results.signed_urls) {
          try {
            // 署名付きURLを使用してplyファイルをダウンロード
            // console.log("★fileInfo.signed_url = ", fileInfo.signed_url);
            const plyResponse = await fetch(fileInfo.signed_url);
            // ファイル名によって設定するファイルの種類を判別
            // ファイル名に「waterdepth」かつ拡張子が「ply」の場合は3D表示用の水深データ
            // ファイル名に「landheight」かつ拡張子が「ply」の場合は3D表示用の地形データ
            // ファイル名に「building」かつ拡張子が「ply」の場合は3D表示用の建物データ
            if (
              fileInfo.name.includes("waterdepth_") &&
              fileInfo.name.includes(".ply")
            ) {
              floodFiles.push(await plyResponse.blob());
              // console.log("★waterdepthFile = ", floodFiles);
            } else if (
              fileInfo.name.includes("landheight") &&
              fileInfo.name.includes(".ply")
            ) {
              landFile = await plyResponse.blob();
              // console.log("★landFile = ", landFile);
            } else if (
              fileInfo.name.includes("building") &&
              fileInfo.name.includes(".ply")
            ) {
              buildingFile = await plyResponse.blob();
              // console.log("★buildingFile = ", buildingFile);
            } else if (
              fileInfo.name.includes("waterdepth2D_") &&
              fileInfo.name.includes(".png")
            ) {
              pngFiles.push(await plyResponse.blob());
              // console.log("★waterdepth2DFile = ", pngFiles);
            }

            // plyFileの処理を行う（ここではファイルのダウンロードが確認できたことをログに出力しています）
          } catch (error) {
            console.error("Error downloading ply file:", error);
          }
        }

        setFileData({
          floodFiles,
          landFile,
          buildingFile,
          pngFiles,
        });
        // モーダルを閉じる
        setIsSettingWindowOpen(false);
      }
    } catch (error) {
      console.error("Error downloading ply file:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative shadow-md sm:rounded-lg">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <div>
          <button
            className="inline-flex items-center text-gray-500 bg-white border border-gray-300 
            focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium 
            rounded-lg text-sm px-3 py-1.5"
            type="button"
            onClick={getSimulationsList}
          >
            更新
          </button>
        </div>
        {/* <div>
          <button
            type="button"
            disabled={!(user["https://hirono-flood-sim/roles"][0] === "exec")}
            className="w-[100%] flex items-center justify-between text-planeText focus:outline-none text-white bg-settingWindowMain 
                    hover:bg-ArithmerBlue focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-planeText px-5 py-2.5 mb-2 dark:bg-purple-600 
                    dark:hover:bg-purple-700 dark:focus:ring-purple-900"
            onClick={() => {
              // setIsSettingWindowOpen(true);
              (async () => {
                await getPastData();
                setModalType("pastFutureData");
              })();
            }}
          >
            <div
              className="flex items-center"
              onClick={() => {
                setReferenceDateTime(new Date());
              }}
            >
              <img src="./img/spanner.png" className="w-[30px]"></img>
              <p className="pl-2">新規シミュレーション実行</p>
            </div>
            <img src="./img/arrow_02.png" className="w-[15px]" />
          </button>
        </div> */}
      </div>
      <table className="w-full text-xs text-left text-gray-500 dark:text-gray-400">
        <thead className="text-gray-700 uppercase bg-gray-50 sticky top-0">
          <tr>
            <th scope="col" className="p-2">
              No.
            </th>
            <th scope="col" className="px-6 py-3">
              シミュレーションID
            </th>
            <th scope="col" className="px-6 py-3">
              開始日時 / 終了日時
            </th>
            <th scope="col" className="px-6 py-3">
              ステータス
            </th>
            <th scope="col" className="px-6 py-3">
              浸水リスク有無
            </th>
            <th scope="col" className="px-6 py-3">
              実行キャンセル
            </th>
            <th scope="col" className="px-6 py-3">
              結果表示
            </th>
          </tr>
        </thead>
        <tbody>
          {simulationList &&
            simulationList.map((simulation, index: number) => {
              return (
                <tr
                  key={index}
                  className="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <td className="w-4 p-4">
                    <div className="font-semibold">{index + 1}</div>
                  </td>
                  <td
                    scope="row"
                    className="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
                  >
                    <div className="pl-3">
                      <p
                        className="cursor-pointer font-semibold text-blue-400 hover:underline"
                        onClick={() => {
                          (async () => {
                            // await getSimulationData(simulation.simu_id);
                            // setModalType("rainfall");
                            await getPastFutureInputData(simulation.simu_id);
                            setModalType("pastFutureDataReference");
                          })();
                          // setIsSettingWindowOpen(true);
                        }}
                      >
                        {simulation.simu_id}
                      </p>
                      <div className="font-normal text-gray-500">
                        {simulation.simu_start_user}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    {`${simulation.simu_start_time} / ${
                      simulation.simu_end_time ??
                      simulation.simu_cancel_end_time ??
                      "-"
                    }`}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div
                        className={`h-2.5 w-2.5 rounded-full mr-2
                    ${
                      simulation.simu_status === "0"
                        ? "bg-green-300"
                        : simulation.simu_status === "1"
                        ? "bg-gray-300"
                        : simulation.simu_status === "2"
                        ? "bg-red-300"
                        : simulation.simu_status === "3"
                        ? "bg-yellow-300"
                        : simulation.simu_status === "4"
                        ? "bg-gray-300"
                        : simulation.simu_status === "5"
                        ? "bg-red-300"
                        : ""
                    }
                    `}
                      ></div>{" "}
                      {simulation.simu_status === "0"
                        ? "実行中"
                        : simulation.simu_status === "1"
                        ? "正常終了"
                        : simulation.simu_status === "2"
                        ? "シミュレーションエラー"
                        : simulation.simu_status === "3"
                        ? "キャンセル中"
                        : simulation.simu_status === "4"
                        ? "キャンセル終了"
                        : simulation.simu_status === "5"
                        ? "キャンセルエラー"
                        : ""}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div
                        className={`h-2.5 w-2.5 rounded-full mr-2
                    ${
                      simulation.is_risk_of_flooding === "1"
                        ? "bg-red-500"
                        : simulation.is_risk_of_flooding === "0"
                        ? "bg-gray-500"
                        : ""
                    }
                    `}
                      ></div>{" "}
                      {simulation.is_risk_of_flooding === "1"
                        ? "有り"
                        : simulation.is_risk_of_flooding === "0"
                        ? "無し"
                        : ""}
                    </div>
                  </td>
                  <td className="px-6 py-4 justify-center">
                    <p className="font-medium text-gray-400 hover:underline">
                      {simulation.simu_status === "0" &&
                      user["https://hirono-flood-sim/roles"][0] === "exec" ? (
                        <button
                          type="button"
                          className="py-2.5 px-5 text-xs font-medium text-gray-900 
                      focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 
                      hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200"
                          onClick={() => {
                            (async () => {
                              await postCancelSimulation(simulation.simu_id);
                              getSimulationsList();
                            })();
                          }}
                        >
                          キャンセル
                        </button>
                      ) : (
                        " "
                      )}
                    </p>
                  </td>
                  <td className="px-6 py-4 flex justify-center">
                    <p className="font-medium text-gray-400 hover:underline">
                      {simulation.simu_status === "1" &&
                      simulation.is_risk_of_flooding === "1" ? (
                        <button
                          type="button"
                          className="py-2.5 px-5 mr-2 mb-2 text-xs font-medium text-gray-900 
                      focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 
                      hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200"
                          onClick={() => {
                            (async () => {
                              await onResultButtonClick(simulation.simu_id);
                            })();
                          }}
                        >
                          結果 表示
                        </button>
                      ) : (
                        " "
                      )}
                    </p>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default SimulationList;
